import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WelcomeDialogDataService {

  private readonly _closeDialog = new Subject<boolean>();
  public closeDialog$: Observable<boolean> = this._closeDialog.asObservable();

  closeDialog(): void {
    this._closeDialog.next(true);
  }

  /**
   * Whether to show the welcome dialog. Hard `false` on purpose: the dialog is only switched on when
   * there is something new to announce, and there is nothing right now.
   *
   * To switch it back on, bump `DIALOG_VERSION` in dialog-version.ts and return
   * "stored version missing or different from DIALOG_VERSION", read from localStorage under
   * `DIALOG_VERSION_KEY`. The component already writes that pair when the dialog is dismissed, so
   * everything except this one condition is still wired up - which is why the version constants are
   * live rather than dead.
   *
   * The condition used to sit here commented out; that is what typescript:S125 flagged, and it is
   * spelled out in prose instead of deleted because the mechanism is the point.
   */
  showDialog(): boolean {
    return false;
  }

}
